import { AppBillingProductFragment } from '@warebee/frontend/app-billing-graphql-api';
import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrencySymbolSettings } from '../common/formatHelper';
import ButtonSwitchMulti from '../components/actions/ButtonSwitchMulti';

export type AppBillingCurrenctySwitcherProps = {
  className?: string;
  products: AppBillingProductFragment[];

  currency: string;
  onCurrencyChange: (currency: string) => void;
};

const AppBillingCurrenctySwitcher: React.FC<
  AppBillingCurrenctySwitcherProps
> = props => {
  const { t } = useTranslation('app');
  const { products, currency } = props;

  const currencies = _(products)
    .map(p => p.prices)
    .flatten()
    .map(price => price.currency.toUpperCase())
    .uniq()
    .value();

  return (
    <div
      data-component="CurrencySwitchContainer"
      className={classNames(
        'items-center',
        'ltr:ml-2 rtl:mr-2',
        props.className,
      )}
    >
      <ButtonSwitchMulti
        autoSize
        buttonType="secondary"
        classNameLabel="!text-lg !lg:text-xl"
        options={currencies.map(currencyCode => ({
          label: getCurrencySymbolSettings(currencyCode).symbol,
        }))}
        selectedIndex={_.indexOf(currencies, currency)}
        onClick={index => props.onCurrencyChange(currencies[index])}
      />
    </div>
  );
};

export default AppBillingCurrenctySwitcher;
